import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, IconButton, Typography } from "@mui/material";

import CreateNewChatPopUp from "../../../components/CreateNewChatPopUp";
import { CreateNewChatIcon } from "../../../assets/icons/chat-page-icons";

const ChatSideBarHeader = ({ isChatLoading }: { isChatLoading: boolean }) => {
  const { t } = useTranslation("chat");
  const [openCreateMessage, setOpenCreateMessage] = useState(false);

  const handleCreateNewChat = () => setOpenCreateMessage(true);
  const handleCloseCreateNewChat = () => setOpenCreateMessage(false);

  return (
    <Box sx={styles.header}>
      <Typography sx={styles.headerTitle} component="h4">
        {t("chat")}
      </Typography>
      <IconButton onClick={handleCreateNewChat} disabled={isChatLoading}>
        <CreateNewChatIcon />
      </IconButton>
      <CreateNewChatPopUp open={openCreateMessage} handleClose={handleCloseCreateNewChat} />
    </Box>
  );
};

export default ChatSideBarHeader;

const styles = {
  header: {
    padding: "0 15px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "27px",
  },
  headerTitle: {
    fontFamily: "Montserrat",
    fontSize: "20px",
    fontWeight: 800,
    lineHeight: "normal",
    color: "var(--Gray-900, #101828)",
    fontStyle: "normal",
  },
};
